module.exports = __webpack_public_path__ + "static/media/8-1.96e702a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/8-1.png
// module id = 1687
// module chunks = 0 1